module.exports = __webpack_public_path__ + "static/media/carousel-city-elements-svgrepo-com.b430d579.svg";